import styled from 'react-emotion';
import { BaseTable } from '../../Symbols/BaseTable'

export const Mandates = styled.div`
	margin: 1.5rem 0 2.5rem 0;
`;

export const Table = styled(BaseTable)`

	margin-bottom: 2rem;

	td {
		padding: 0.2rem 0.5rem;
		font-size: 0.9rem;
		font-weight: 300;
		text-align: left;
	}

	@media (max-width: 720px) {
		td:nth-child(1) {
			display: none;
		}
	}

	@media (max-width: 374px) {
		td {
			padding: 0.2rem;
		}
	}
`;

export const PartyTitle = styled.th`
	background-color: #FFF;
	color: #000;
	font-size: 1rem;
	font-weight: 400;
	text-align: left;

	@media (max-width: 480px) {
		line-height: 1.25;
		padding: .8125rem 0.5rem;
	}
`;

export const PartyMandates = styled.span`
	display: inline-block;
	float: none;
	font-size: 0.8rem;
	font-weight: 300;
`;

export const Position = styled.td`
	color: #878787;
	font-size: 0.8rem;
	width: 1.25rem;
`;

export const Mandate = styled.td`
	width: 23rem;
`;

export const Info = styled.p`
	font-size: 0.875rem;
	text-align: right;
`
